export function getNewKey(value): string {
  return value || new Date().toString();
}
